export const isHtml = (text?: string) => {
    if (!text) {
        return false;
    }
    return /<\/?[a-z][\s\S]*>/i.test(text);
};
